import { AuthUserType, ContentfulType } from "../../Actions/Types"
import { Reducer } from "redux"
import { AuthAction } from "../Auth"
import { Entry } from "contentful"
import {
    getInitialData,
    mergeRecords,
    mergeErrors,
    RemoteData,
    setList
} from "../../Models/Client/RemoteData"
import { DataProgramModel } from "../../Models/External/Contentful"
import { TemplateSlug } from "../../Models/API/AppTemplateModel"
import { Map } from "immutable"
import { hasValue } from "../../Models/Client/FetchState"

export interface ContentfulState {
    dataPrograms: RemoteData<Entry<DataProgramModel>, {}, TemplateSlug>
}

interface ContentfulReceiveDataProgramList {
    type: ContentfulType.receiveDataProgramList
    payload: Entry<DataProgramModel>[]
}

interface ContentfulRequestDataProgram {
    type: ContentfulType.requestDataProgram
    payload: TemplateSlug
}

interface ContentfulReceiveDataProgram {
    type: ContentfulType.receiveDataProgram
    payload: Entry<DataProgramModel>
}

interface ContentfulReceiveDataProgramErrors {
    type: ContentfulType.receiveDataProgramErrors
    payload: Map<TemplateSlug, string>
}

export type ContentfulAction =
    | ContentfulReceiveDataProgramList
    | ContentfulRequestDataProgram
    | ContentfulReceiveDataProgram
    | ContentfulReceiveDataProgramErrors

const initialState: ContentfulState = {
    dataPrograms: getInitialData()
}

const getDataProgramId = (e: Entry<DataProgramModel>) =>
    TemplateSlug(e.fields.slug)

export const ContentfulReducer: Reducer<
    ContentfulState,
    ContentfulAction | AuthAction
> = (state = initialState, action): ContentfulState => {
    switch (action.type) {
        case ContentfulType.requestDataProgram:
            return {
                ...state,
                dataPrograms: {
                    list: state.dataPrograms.list,
                    records: state.dataPrograms.records.update(
                        action.payload,
                        undefined,
                        current => (hasValue(current) ? current : "loading")
                    )
                }
            }
        case ContentfulType.receiveDataProgram:
            return {
                ...state,
                dataPrograms: {
                    list: state.dataPrograms.list,
                    records: mergeRecords(
                        state.dataPrograms.records,
                        [action.payload],
                        getDataProgramId
                    )
                }
            }
        case ContentfulType.receiveDataProgramErrors:
            return {
                ...state,
                dataPrograms: {
                    list: state.dataPrograms.list,
                    records: mergeErrors(
                        state.dataPrograms.records,
                        action.payload
                    )
                }
            }
        case ContentfulType.receiveDataProgramList:
            return {
                ...state,
                dataPrograms: setList(
                    state.dataPrograms,
                    {},
                    action.payload,
                    getDataProgramId
                )
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
